module.exports = __webpack_public_path__ + "img/day4.c50dd69c.jpeg";